export default {"src":"/frontend-static/_next/static/media/afterpay_badge.f03cacef.svg","height":106,"width":166,"blurWidth":0,"blurHeight":0};